export default __webpack_public_path__ + "static/miniProgramCode-84a8345a08f9e86e32eab9c35df1dc12.png";